module.exports = __webpack_public_path__ + "img/status_approving-01.48f66ba2.png";